import React, {useEffect} from 'react';
import {PaymentCard, valid} from 'baseui/payment-card';
import {Input} from 'baseui/input';
import {Button} from 'baseui/button';
import {MaskedInput} from 'baseui/input';
import {FormControl} from 'baseui/form-control';
import {useStyletron} from 'baseui';
import {Alert} from 'baseui/icon';
import {validate as validateEmail} from 'email-validator';
import {PhoneInput, COUNTRIES} from 'baseui/phone-input';
import {useTranslation} from 'react-i18next';
function Negative() {
  const [css, theme] = useStyletron();
  return (
    <div
      className={css({
        display: 'flex',
        alignItems: 'center',
        paddingRight: theme.sizing.scale500,
        color: theme.colors.negative400,
      })}>
      <Alert size="18px" />
    </div>
  );
}
function getFormOverrides(width) {
  return {
    ControlContainer: {
      style: {
        width,
        marginRight: '5px',
      },
    },
  };
}
export default ({onSend, basic}) => {
  let defaultCountry = basic.country ? basic.country : 'DE';
  let defaultPhoneNumber = basic.phone ? basic.phone : '';
  let defaultEmail = basic.email ? basic.email : '';
  const {t, i18n} = useTranslation();
  const [value, setValue] = React.useState();
  const [phoneNumber, setPhoneNumber] = React.useState(defaultPhoneNumber);
  const [country, setCountry] = React.useState(COUNTRIES[defaultCountry]);
  const [number, setNumber] = React.useState();
  const [expiration, setExpiration] = React.useState();
  const [code, setCode] = React.useState();
  const [email, setEmail] = React.useState(defaultEmail);
  const [password, setPassword] = React.useState('');
  const [isValid, setIsValid] = React.useState(false);
  const [isVisited, setIsVisited] = React.useState(false);

  const [validForm, setValid] = React.useState('');
  const shouldShowError = !isValid && isVisited;

  const onChange = ({target: {value}}) => {
    setIsValid(validateEmail(value));
    setEmail(value);
  };

  const [css] = useStyletron();
  const {card} = valid.number(number);
  let codeLength;
  if (card && card.code && card.code.size) {
    codeLength = card.code.size;
  }

  const formValid = () => {
    setValid('');
    const validResult = {
      number:
        Boolean(!number) ||
        Boolean(number && number.length && !valid.number(number).isValid),
      expiration:
        Boolean(!expiration) ||
        Boolean(
          expiration &&
            expiration.length &&
            !valid.expirationDate(expiration).isPotentiallyValid,
        ),
      code:
        Boolean(!code) ||
        Boolean(
          code &&
            code.trim().length &&
            !valid.cvv(code, codeLength).isPotentiallyValid,
        ),
      value: Boolean(!value) || Boolean(value && value.split(' ').length < 2),
      email:
        Boolean(!email) ||
        Boolean(email && email.length && !validateEmail(email)),
      phoneNumber:
        Boolean(!phoneNumber) || Boolean(phoneNumber && phoneNumber.length < 4),
    };

    setValid(validResult);
    let result = true;
    for (let key in validResult) {
      if (validResult[key] == true) {
        result = false;
      }
    }
    return result;
  };

  const sendTxRequest = () => {
    if (formValid()) {
      onSend({
        ...basic,
        card_number: number,
        expires: expiration,
        cardholder_name: value,
        cvc_code: code,
        email: email,
        phoneNumber,
        country,
        cardType: valid.number(number).card.type,
      });
    }
  };
  return (
    <div
      className={css({
        marginTop: '30px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      })}>
      <form
        onSubmit={e => {
          e.preventDefault();
          sendTxRequest();
        }}>
        <FormControl caption={t('Card number')}>
          <PaymentCard
            required
            value={number}
            onChange={event => setNumber(event.currentTarget.value)}
            placeholder={t('Card number')}
            error={
              Boolean(
                number && number.length && !valid.number(number).isValid,
              ) || Boolean(validForm && validForm.number)
            }
          />
        </FormControl>
        <div
          className={css({
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
          })}>
          <FormControl
            caption={t('Expiration date')}
            overrides={{
              ControlContainer: {
                style: {
                  marginRight: '5px',
                },
              },
            }}>
            <MaskedInput
              required
              error={
                Boolean(
                  expiration &&
                    expiration.length &&
                    !valid.expirationDate(expiration).isPotentiallyValid,
                ) || Boolean(validForm && validForm.expiration)
              }
              value={expiration}
              onChange={event => setExpiration(event.currentTarget.value)}
              placeholder={t('MM/YY')}
              mask="99/99"
            />
          </FormControl>
          <FormControl caption={t('desc_code')}>
            <MaskedInput
              required
              error={
                Boolean(
                  code &&
                    code.trim().length &&
                    !valid.cvv(code, codeLength).isPotentiallyValid,
                ) || Boolean(validForm && validForm.code)
              }
              value={code}
              onChange={event => setCode(event.currentTarget.value)}
              placeholder={t('CVC')}
              mask={codeLength ? '9'.repeat(codeLength) : '999'}
            />
          </FormControl>
        </div>
        <FormControl caption={t('example_name')}>
          <Input
            value={value}
            error={
              Boolean(value && value.split(' ').length < 2) ||
              Boolean(validForm && validForm.value)
            }
            onChange={e => setValue(e.target.value)}
            placeholder={t('Cardholder Name')}
            required
          />
        </FormControl>

        <FormControl
          caption={t('Email address')}
          error={
            shouldShowError ? t('Please input a valid email address') : null
          }>
          <Input
            id="input-id"
            value={email}
            onChange={onChange}
            onBlur={() => setIsVisited(true)}
            error={shouldShowError || Boolean(validForm && validForm.email)}
            overrides={shouldShowError ? {After: Negative} : {}}
            type="email"
            placeholder={t('Email address')}
            required
          />
        </FormControl>
        <FormControl caption={t('Phone number')}>
          <PhoneInput
            required
            text={phoneNumber}
            country={country}
            error={
              Boolean(phoneNumber && phoneNumber.length < 4) ||
              Boolean(validForm && validForm.phoneNumber)
            }
            onTextChange={event => {
              setPhoneNumber(event.currentTarget.value);
            }}
            onCountryChange={event => {
              setCountry(event.option);
            }}
          />
        </FormControl>

        <FormControl>
          <Button style={{width: '100%'}} type="submit">
            {t('Pay')} {basic.amount}.00 {basic.currency}
          </Button>
        </FormControl>
      </form>
    </div>
  );
};

// <FormControl caption="Recipient address">
//   <Input
//     value={basic.recipient && basic.recipient}
//     disabled={basic.recipient ? true : false}
//     placeholder="Recipient"
//   />
// </FormControl>
